import React from 'react';
import {
	MapModeStrategy,
	Infrastructure,
	PopupData,
	FetchParams,
	MapModeContext,
	DigitalTwinContext,
} from './MapModeStrategy';

const PopupComponent = React.lazy(() => import('../Popup.jsx'));

class DmaModeStrategy implements MapModeStrategy {
	name = 'dma';
	displayName = 'DMA Lens';

	filterInfrastructures(
		infras: Infrastructure[],
		context: MapModeContext,
		selectedTypes: string[]
	): Infrastructure[] {
		if (!infras) return [];
		return infras.filter((infra) => selectedTypes.includes(infra.infrastructureTypeName));
	}

	calculateOpacities(
		infras: Infrastructure[],
		context: MapModeContext,
		digitalTwinContext?: DigitalTwinContext
	): Record<number, number> {
		const opacities: Record<number, number> = {};
		if (!infras) return opacities;
		infras.forEach((infra) => {
			opacities[infra.measurementeInfraestructureId] = 1.0;
		});
		return opacities;
	}

	async handleAssetClick(
		infra: Infrastructure,
		context: MapModeContext
	): Promise<PopupData> {
		return {
			measurementeInfraestructureId: infra.measurementeInfraestructureId,
			measurementInfraestructureName: infra.measurementInfraestructureName,
			infrastructureTypeName: infra.infrastructureTypeName,
			expired: infra.mainMeasurementTarget?.expired,
		};
	}

	PopupComponent = PopupComponent;

	getFetchParams(context: MapModeContext): FetchParams {
		return {
			mode: 'dma',
		};
	}

	getHighlightedAssets(
		context: MapModeContext,
		digitalTwinContext?: DigitalTwinContext
	): Set<number> | null {
		return null;
	}

	getPopupProps(
		infraInfo: PopupData,
		context: MapModeContext,
		additionalData?: any
	): Record<string, any> {
		return {
			data: infraInfo,
			id: infraInfo.measurementeInfraestructureId,
		};
	}
}

export const dmaModeStrategy = new DmaModeStrategy();
export default DmaModeStrategy;
